<template>
  <div
    v-if="hasRole('ui', 'UI_ENABLED_WATERMARK')"
    class="watermark"
    :style="`background-image: url(${base64Image});`"
  />
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import textToImg from 'utils/textToImg'
import moment from 'moment'

export default {
  name: 'Watermark',
  computed: {
    ...mapState({
      user: ({ session }) => session.user
    })
  },
  data () {
    return {
      base64Image: null
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    renderWatermark () {
      if (this.hasRole('ui', 'UI_ENABLED_WATERMARK')) {
        const { email = '', legacyUserId = '' } = this.user.business
        const date = moment().format('YYYY-MM-DD')
        const str = `${legacyUserId} ${email} ${date}`

        const optionsParameter = {
          width: 600,
          height: 250,
          paddingX: 20,
          paddingY: 100,
          font: ['16px', 'Arial'],
          color: '#aaa',
          textString: str
        }

        this.base64Image = textToImg(optionsParameter).base64Image
      }
    }
  },
  mounted () {
    this.renderWatermark()
  }
}
</script>

<style lang="scss" scoped>
.watermark {
  background-position: left top;
  background-repeat: repeat;
  bottom: -2000px;
  left: -2000px;
  opacity: .2;
  pointer-events: none;
  position: fixed;
  right: -2000px;
  top: -2000px;
  transform: rotate(35deg);
  z-index: 10000;
}
</style>
